// extracted by mini-css-extract-plugin
export default {"asterisk":"asterisk---sqnp5","hasError":"hasError---uJA3H"};